export default __webpack_public_path__ + "static/kb_1_5-6ea6e63a457312d5359a5bfa0fd8a4a5.jpeg";